import { IconType, SvgIcon } from './SvgIcon';

export const MicrophoneDisabledIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <g clipPath="url(#clip0_1406_5712)">
      <path
        d="M1.66602 1.66699L18.3327 18.3337"
        stroke="currentColor"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7422 11.0247C15.8024 10.6863 15.833 10.3434 15.8339 9.99967V8.33301"
        stroke="currentColor"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.16663 8.33301V9.99967C4.14968 11.1656 4.48256 12.3099 5.12233 13.2849C5.76209 14.2598 6.67936 15.0206 7.75576 15.4691C8.83216 15.9176 10.0183 16.0332 11.161 15.801C12.3037 15.5688 13.3507 14.9994 14.1666 14.1663"
        stroke="currentColor"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5009 7.78325V4.16658C12.4975 3.60522 12.3053 3.06134 11.9552 2.62251C11.6051 2.18369 11.1175 1.87547 10.5709 1.74748C10.0243 1.6195 9.45059 1.6792 8.94206 1.91697C8.43354 2.15474 8.01983 2.55675 7.76758 3.05825"
        stroke="currentColor"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 7.5V10C7.50043 10.4941 7.64729 10.9771 7.92203 11.3878C8.19676 11.7985 8.58704 12.1186 9.04359 12.3076C9.50013 12.4967 10.0025 12.5462 10.4871 12.4499C10.9718 12.3536 11.417 12.1159 11.7667 11.7667"
        stroke="currentColor"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 15.833V18.333"
        stroke="currentColor"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1406_5712">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);

MicrophoneDisabledIcon.displayName = 'MicrophoneDisabledIcon';
